/** 모비온 원태그 광고주 고유값 (adverId `myrealtripweb` 계정, 모비온 발급) */
export const ONETAG_EID = 'sl3d838ddmjlsl3d838ddm';

/**
 * 모비온 원태그 컨테이너 스크립트 URL (콘솔 공식 설치형)
 * 컨테이너가 콘솔에 발행된 스크립트(현재: 데이터매니저 tcsdm.js)를 자동 주입하므로,
 * 이후 모비온 측 스크립트 교체·버전업은 코드 배포 없이 콘솔에서 반영된다.
 */
export const ONETAG_SCRIPT_SRC = `https://cdn.onetag.co.kr/0/tcs.js?eid=${ONETAG_EID}`;
